module.exports = __webpack_public_path__ + "static/media/ArrowLeft.866ba6b5.svg";